import { useQuery, keepPreviousData } from '@tanstack/react-query'
import {
  getAgentCommissions,
  getAgentProducts,
  getApps,
  getAppsV3,
  getFactTableApps,
  getFactTableAppsV2,
  getMetrics,
  getMetricsV3,
  getProducerProfile,
  getUserPersona,
} from './apis'
import {
  decryptLink,
  listOfAppStatuses,
  listOfAppStatusesV2,
  listOfProducts,
  statusCompletions,
  statusCompletionsV2,
  statusCompletionsV3,
} from '../utils/table'
import { convertDbTimestampToString } from '../utils'

const isJSON = (str) => {
  try {
    if (str === null) return false
    JSON.parse(str)
  } catch (e) {
    return false
  }
  return true
}

export const UseUserPersona = (username) => {
  return useQuery({
    queryKey: ['userPersona', { login: username }],
    queryFn: getUserPersona,
    staleTime: Infinity,
    enabled: !!username,
  })
}

export const FetchApps = (affiliateCode) => {
  return useQuery({
    queryKey: ['apps', { affiliateCode }],
    queryFn: getApps,
    staleTime: Infinity,
    enabled: !!affiliateCode,
    select: (data) => {
      console.log({ data })
      try {
        let formattedRows = []
        data.forEach((app) => {
          let isjson = isJSON(app.policyNo)
          // console.log({ isjson, app })
          if (isjson) {
            // app.appStatus = app.appStatus.replace(/'/g, '"').replace(/None/g, null)
            app.policyNo = app.policyNo.replace(/'/g, '"').replace(/None/g, null)
            // let statusJSON = JSON.parse(app.appStatus)
            let policyJSON = JSON.parse(app.policyNo)
            const allKeys = new Set([...Object.keys(policyJSON)])
            // console.log({ allKeys })
            if (Array.from(allKeys).includes('rolePO')) {
              formattedRows.push({
                ...app,
                status: listOfAppStatusesV2[app.appStatus],
                appStatus: statusCompletionsV2(app.appStatus),
                productName: listOfProducts[app.productId],
                policyNo: policyJSON['rolePO'] || '',
                applicationDate: convertDbTimestampToString(app.applicationDate),
                ownerName: app.ownerDetails
                  ? `${app.ownerDetails?.ownerFirstName} ${app.ownerDetails?.ownerLastName}`
                  : '',
              })
            } else if (Array.from(allKeys).includes('rolePI')) {
              formattedRows.push({
                ...app,
                status: listOfAppStatusesV2[app.appStatus],
                appStatus: statusCompletionsV2(app.appStatus),
                productName: listOfProducts[app.productId],
                policyNo: policyJSON['rolePI'] || '',
                applicationDate: convertDbTimestampToString(app.applicationDate),
                ownerName: app.ownerDetails
                  ? `${app.ownerDetails?.ownerFirstName} ${app.ownerDetails?.ownerLastName}`
                  : '',
              })
            }
            // const roleWise = Array.from(allKeys).map((role) => {
            //   console.log({
            //     arcId: app.arcId,
            //     status: listOfAppStatuses[statusJSON[role]],
            //     appStatus: statusCompletions(statusJSON[role]),
            //   })
            //   return {
            //     ...app,
            //     status: listOfAppStatuses[statusJSON[role]],
            //     appStatus: statusCompletions(statusJSON[role]),
            //     productName: listOfProducts[app.productId],
            //     policyNo: policyJSON[role] || '',
            //     applicationDate: convertDbTimestampToString(app.applicationDate),
            //     ownerName: app.ownerDetails
            //       ? `${app.ownerDetails?.ownerFirstName} ${app.ownerDetails?.ownerLastName}`
            //       : '',
            //   }
            // })

            // formattedRows.push(...roleWise)
          } else {
            formattedRows.push({
              ...app,
              status: listOfAppStatusesV2[app.appStatus],
              appStatus: statusCompletionsV2(app.appStatus),
              productName: listOfProducts[app.productId],
              applicationDate: convertDbTimestampToString(app.applicationDate),
              ownerName: app.ownerDetails
                ? `${app.ownerDetails?.ownerFirstName} ${app.ownerDetails?.ownerLastName}`
                : '',
            })
          }
        })
        // const apps = data.map((app) => ({
        //   ...app,
        //   status: listOfAppStatuses[app.appStatus],
        //   appStatus: statusCompletions(app.appStatus),
        //   productName: listOfProducts[app.productId],
        //   applicationDate: convertDbTimestampToString(app.applicationDate),
        // }))
        console.log({ formattedRows })
        return formattedRows
      } catch (error) {
        console.log({ error })
        return []
      }
    },
  })
}

export const FetchMetrics = (affiliateCode) => {
  return useQuery({
    queryKey: ['metrics', { affiliateCode }],
    queryFn: getMetrics,
    staleTime: Infinity,
    enabled: !!affiliateCode,
    select: (data) => {
      const { summarizedData } = data
      // console.log({ summarizedData })
      return summarizedData
    },
  })
}

export const FetchFactTableApps = (affiliateCode) => {
  return useQuery({
    queryKey: ['factTableApps', { affiliateCode }],
    queryFn: getFactTableApps,
    staleTime: Infinity,
    enabled: !!affiliateCode,
    select: (data) => {
      const ftapps = data.fact_table_applications.map((app) => ({
        ...app,
        productName: listOfProducts[app.productId],
        appStatus: app.appStatus ? app.appStatus.trim() : 'Not Started',
        appAge: app.app_age,
        arcId: app.arcid,
      }))
      return ftapps
    },
  })
}

export const FetchFactTableAppsV2 = (affiliateCode) => {
  return useQuery({
    queryKey: ['factTableAppsV2', { affiliateCode }],
    queryFn: getFactTableAppsV2,
    staleTime: Infinity,
    enabled: !!affiliateCode,
    select: (data) => {
      console.log('fctTable: ', { data })
      const ftapps = data.fact_table_applications.map((app) => ({
        ...app,
        productName: listOfProducts[app.productId],
        appStatus: app.appStatus ? app.appStatus.trim() : 'Not Started',
        appAge: app.app_age,
        arcId: app.arcid,
      }))
      return ftapps
    },
  })
}

export const FetchAgentProducts = (affiliateCode) => {
  return useQuery({
    queryKey: ['agentProducts', { affiliateCode }],
    queryFn: getAgentProducts,
    staleTime: Infinity,
    enabled: !!affiliateCode,
    select: (data) => {
      const products = data.map(({ productId, productName, productUrl }) => ({
        productId,
        productName,
        productUrl,
      }))
      return products
    },
  })
}

export const FetchAppsV3 = (queryParams) => {
  return useQuery({
    queryKey: ['appsV3', queryParams],
    queryFn: getAppsV3,
    select: (data) => {
      let rows = data?.rows
      try {
        rows = rows.map((app) => {
          return {
            ...app,
            status: app.appStatus,
            appStatus: statusCompletionsV3(app.appStatus),
            productName: listOfProducts[app.productId],
            applicationDate: convertDbTimestampToString(app.applicationDate),
            uwReportLink: app.uwReportLink ? decryptLink(app.uwReportLink) : null,
            appPacketURL: app.appPacketURL ? decryptLink(app.appPacketURL) : null,
            policyPacketURL: app.policyPacketURL ? decryptLink(app.policyPacketURL) : null,
          }
        })
      } catch (error) {
        console.log('ERROR by manipulating data: ', { error })
      }
      return { ...data, rows }
    },
    // placeholderData: keepPreviousData,
    refetchOnWindowFocus: false,
    // staleTime: 15 * 60 * 1000,
  })
}

export const FetchProducerProfile = (queryParams) => {
  return useQuery({
    queryKey: ['producerProfile', queryParams],
    queryFn: getProducerProfile,
    // select: (data) => {
    //   const rows = data?.rows
    //   const apps = rows.map((app) => ({
    //     ...app,
    //     status: app.appStatus,
    //     appStatus: statusCompletionsV3(app.appStatus),
    //     productName: listOfProducts[app.productId],
    //     applicationDate: convertDbTimestampToString(app.applicationDate),
    //   }))
    //   return { ...data, rows: apps }
    // },
    placeholderData: keepPreviousData,
    // refetchOnWindowFocus: false,
    // staleTime: 15 * 60 * 1000,
  })
}

export const FetchMetricsV3 = (affiliateCode) => {
  return useQuery({
    queryKey: ['metricsV3', { affiliateCode }],
    queryFn: getMetricsV3,
    staleTime: Infinity,
    enabled: !!affiliateCode,
    select: (data) => {
      const { summarizedData } = data
      // console.log({ summarizedData })
      return summarizedData
    },
  })
}

export const FetchAgentCommissions = (queryParams) => {
  return useQuery({
    queryKey: ['agentCommissions', queryParams],
    queryFn: getAgentCommissions,
    // select: (data) => {
    //   const rows = data?.rows
    //   const apps = rows.map((app) => ({
    //     ...app,
    //     status: app.appStatus,
    //     appStatus: statusCompletionsV3(app.appStatus),
    //     productName: listOfProducts[app.productId],
    //     applicationDate: convertDbTimestampToString(app.applicationDate),
    //   }))
    //   return { ...data, rows: apps }
    // },
    placeholderData: keepPreviousData,
    // refetchOnWindowFocus: false,
    // staleTime: 15 * 60 * 1000,
  })
}